import React from 'react';
import { useSelector } from 'react-redux';
import orderBy from 'lodash/orderBy';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Components
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import { WpButton } from 'Wpds/components/button';
import FilterListItem from './FilterListItem';

// Styles
import './UsersFilterList.scss';

type UsersFilterListItemProps = {
  user?;
  selectedUsers: Array<number>;
  updateFilters: Function;
};

const UsersFilterListItem = ({ user, selectedUsers = [], updateFilters }: UsersFilterListItemProps) => {
  const isChecked = selectedUsers.includes(user.id);

  const handleChange = (checked: boolean) => {
    if (updateFilters) {
      if (checked) updateFilters({ users: [...selectedUsers, user.id] });
      else updateFilters({ users: selectedUsers.filter(selectedUser => selectedUser !== user.id) });
    }
  };

  return (
    <FilterListItem id={user.id} label={user.label} isChecked={isChecked} onChange={handleChange}>
      <div className="UsersFilterList__item">
        <div className="UsersFilterList__item__avatar">
          <WpAvatar avatar={user.avatar} size="sm" />
        </div>
        <div className="UsersFilterList__item__name">{user.label}</div>
      </div>
    </FilterListItem>
  );
};

type Props = {
  selectedUsers: Array<number>;
  updateFilters: Function;
};
const UsersFilterList = ({ selectedUsers, updateFilters }: Props) => {
  const [isShowingAll, toggleIsShowingAll] = useToggle(false);
  const teamSyncWorkspace = useSelector(state => state.workspaces.find(({ isTeamSync }) => isTeamSync));
  let users = teamSyncWorkspace?.users || [];

  const orderAlphabetically = list => {
    return orderBy(list, ({ label }) => label);
  };

  const shouldTruncateUsers = !isShowingAll && users.length > 5;

  users = orderAlphabetically(users);
  users = shouldTruncateUsers ? users.slice(0, 5) : users;

  return (
    <div>
      {users.map(user => (
        <UsersFilterListItem
          key={`${user.id}`}
          user={user}
          selectedUsers={selectedUsers}
          updateFilters={updateFilters}
        />
      ))}
      {shouldTruncateUsers && (
        <WpButton size="sm" variant="tertiary" onClick={toggleIsShowingAll}>
          see more
        </WpButton>
      )}
    </div>
  );
};

export default UsersFilterList;
